import { memo, useState } from "react"
import { CSSTransition } from "react-transition-group";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import MasterAPI from "service/master";

const Feedback = props => {
    const { isUseful } = props;
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [localUseful, setLocalUseful] = useState(null);
    const actionAvaible = !isUseful && !localUseful;

    const submitHandler = async isUsefulData => {
        if (loading)
            return;

        if (!actionAvaible) {
            toast.error("قبلا برای این تیکت بازخورد ثبت کرده اید");
            return;
        }

        setLoading(isUsefulData ? 1 : 2);
        try {
            const res = await MasterAPI({
                url: "/api/ticket/set_is_useful",
                method: "PUT",
                data: {
                    id,
                    is_useful: isUsefulData
                },
                callback: () => setLoading(false),
                payloadType: 3
            });

            toast.success(res.message);
            setLocalUseful(isUsefulData);
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <div className={`ticket-feedback ${actionAvaible ? "avaible" : "disable"}`}>
            <button className={`like ${isUseful || localUseful ? "avaible-btn" : ""}`} onClick={() => submitHandler(true)}>
                <i className="fa-light fa-thumbs-up"></i>
                مفید

                <CSSTransition in={loading === 1} timeout={200} unmountOnExit={true}>
                    <div className="loading-c4 anim-c4">
                        <i className="fa-solid fa-spinner spin"></i>
                    </div>
                </CSSTransition>
            </button>

            <button className={`dislike ${isUseful === false || localUseful === false ? "avaible-btn" : ""}`} onClick={() => submitHandler(false)}>
                <i className="fa-light fa-thumbs-down"></i>
                نامفید

                <CSSTransition in={loading === 2} timeout={200} unmountOnExit={true}>
                    <div className="loading-c4 anim-c4">
                        <i className="fa-solid fa-spinner spin"></i>
                    </div>
                </CSSTransition>
            </button>
        </div>
    )
}

export default memo(Feedback);